import React, { useReducer, useState } from "react";
import { gigReducer, INITIAL_STATE } from "../../reducers/gigReducer";
import "./Add.scss";
import upload from "../../utils/upload";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import newRequest from "../../utils/newRequest";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Add = () => {
  const [singleFile, setSingleFile] = useState(undefined);
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [state, dispatch] = useReducer(gigReducer, INITIAL_STATE);

  //handle Change
  const handleChange = (e) => {
    dispatch({
      type: "CHANGE_INPUT",
      payload: { name: e.target.name, value: e.target.value },
    });
  };

  //handle Feature
  const handleFeature = (e) => {
    e.preventDefault();
    dispatch({
      type: "ADD_FEATURE",
      payload: e.target[0].value,
    });
    e.target[0].value = "";
  };

  //handle Upload
  const handleUpload = async () => {
    setUploading(true);
    try {
      const cover = await upload(singleFile);
      const images = await Promise.all(
        [...files].map(async (file) => {
          const url = await upload(file);
          return url;
        })
      );
      setUploading(false);
      dispatch({ type: "ADD_IMAGES", payload: { cover, images } });
    } catch (err) {
      console.log(err);
    }
  };

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (gig) => {
      return newRequest.post("/gigs/add", gig);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["myGigs"]);
      toast.success("Gig Created !");
      navigate("/mygigs");
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message ||
          "An error occurred while creating the gig."
      );
    },
  });

  //handle Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate(state);
  };

  return (
    <div className="add">
      <div className="add-container">
        <h1>Add New Gig</h1>
        <div className="add-sections">
          <div className="add-left">
            <label htmlFor="title">Title</label>
            <input
              type="text"
              name="title"
              id="title"
              placeholder="e.g. I will do something I'm really good at"
              onChange={handleChange}
            />
            <label htmlFor="category">Category</label>
            <select name="cat" id="cat" onChange={handleChange}>
              <option value="ai">AI</option>
              <option value="design">Design</option>
              <option value="web">Web developement</option>
              <option value="animation">Animation</option>
              <option value="music">Music</option>
            </select>
            <div className="images">
              <div className="imagesInputs">
                <label htmlFor="Cover Image">Cover Image</label>
                <input
                  type="file"
                  onChange={(e) => setSingleFile(e.target.files[0])}
                />
                <label htmlFor="Upload Images">Upload Images</label>
                <input
                  type="file"
                  multiple
                  onChange={(e) => setFiles(e.target.files)}
                />
              </div>
              <button className="btn" onClick={handleUpload}>
                {uploading ? "uploading" : "Upload"}
              </button>
            </div>

            <label htmlFor="Description">Description</label>
            <textarea
              name="desc"
              id="desc"
              cols="0"
              rows="16"
              placeholder="Brief descriptions to introduce your service to customers"
              onChange={handleChange}
            ></textarea>
            <button
              onClick={handleSubmit}
              disabled={uploading}
              className={`btn ${uploading ? "disabled" : ""}`}
            >
              {uploading ? "Please wait ..." : "Create"}
            </button>
          </div>

          <div className="add-right">
            <label htmlFor="Description">Service Title</label>
            <input
              type="text"
              placeholder="e.g. One-page web design"
              onChange={handleChange}
              name="serviceTitle"
            />
            <label htmlFor="Short Description">Short Description</label>
            <textarea
              id=""
              cols="30"
              rows="10"
              placeholder="Short description of your service"
              name="shortDesc"
              onChange={handleChange}
            ></textarea>
            <label htmlFor="Delivery Time (e.g. 3 days)">
              Delivery Time (e.g. 3 days)
            </label>
            <input
              type="number"
              min={1}
              name="deliveryTime"
              onChange={handleChange}
            />
            <label htmlFor="Revision Number">Revision Number</label>
            <input
              type="number"
              min={1}
              name="revisionNumber"
              onChange={handleChange}
            />
            <label htmlFor="Add Features">Add Features</label>
            <form action="" className="add" onSubmit={handleFeature}>
              <input type="text" placeholder="e.g. page design" />
              <button className="btn" type="submit">
                add
              </button>
            </form>

            <div className="addedFeatures">
              {state?.features?.map((f) => (
                <div className="item" key={f}>
                  <button
                    onClick={() =>
                      dispatch({ type: "REMOVE_FEATURE", payload: f })
                    }
                  >
                    {f}
                    <span>X</span>
                  </button>
                </div>
              ))}
            </div>
            <label htmlFor="Price">Price</label>
            <input type="number" min={0} onChange={handleChange} name="price" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
